import type { RecentAdsProps } from '../../../features/landing/RecentAds/RecentAds.typed';

import { ErrorBoundary } from '@dist-marketplace-frontend/components';
import convertToFriendlyPath from '../../../utils/FriendlyPath';

import { RecentAdsCard } from '../../../features/landing/RecentAds/RecentAdsCard';
import { Link } from '../../../components/Toolkit/Button/Link';

import {
  Container,
  HeaderContainer,
  AdGrid,
  Heading,
  CardLink,
} from '../../../features/landing/RecentAds/RecentAds.styled';

const RecentAds = (props: RecentAdsProps) => {
  const { domain, recentAds, recentAdsUrl } = props;

  return (
    <div className="row small-collapse medium-uncollapse set-width-100">
      <div className="columns small-12">
        <Container>
          <HeaderContainer>
            <Heading>Recent ads</Heading>
            {recentAdsUrl && (
              <Link href={recentAdsUrl} ofType="SECONDARY" underline>
                See All
              </Link>
            )}
          </HeaderContainer>
          <ErrorBoundary>
            <AdGrid data-testid="recent-ads-list">
              {recentAds.map((ad) => {
                const { id, friendlyUrl } = ad;

                const friendlyPath = convertToFriendlyPath(
                  domain,
                  friendlyUrl!,
                );

                return (
                  <li key={id}>
                    <CardLink href={friendlyPath}>
                      <RecentAdsCard {...ad} />
                    </CardLink>
                  </li>
                );
              })}
            </AdGrid>
          </ErrorBoundary>
        </Container>
      </div>
    </div>
  );
};

export { RecentAds };
